function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Icon, { SHAPES } from './Icon';
import IconButton from './IconButton';
import classifierValues from '../static/classifier.json';
import '../css/libstyle.css';
import { libstyle } from './styleParser';

var IconLibrary = function (_Component) {
  _inherits(IconLibrary, _Component);

  function IconLibrary(props) {
    _classCallCheck(this, IconLibrary);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = {
      currentIcons: {
        name: 'corporate',
        family: 'Corporate',
        data: props.corporateIcons
      }
    };
    _this.handleFamilyChanged = _this.handleFamilyChanged.bind(_this);
    return _this;
  }

  IconLibrary.prototype.handleFamilyChanged = function handleFamilyChanged(evt) {
    var currIcons = void 0;

    if (evt.target.value === 'corporate') {
      currIcons = {
        name: 'corporate',
        family: 'Corporate',
        data: this.props.corporateIcons
      };
    } else {
      currIcons = classifierValues[evt.target.value]; //console.log(currIcons);
    }

    if (!currIcons) {
      currIcons = {
        name: 'none',
        family: 'None',
        data: []
      };
    }

    var family = evt.target.value;
    this.setState({
      currentIcons: currIcons,
      currFamily: family
    });
  };

  IconLibrary.prototype.render = function render() {
    var iconClassifierKeys = Object.keys(classifierValues).sort();
    return React.createElement('div', null, React.createElement('div', null, React.createElement('select', {
      onChange: this.handleFamilyChanged
    }, React.createElement('option', {
      key: 'corporate',
      value: 'corporate'
    }, 'Corporate'), iconClassifierKeys.map(function (typeName) {
      return React.createElement('option', {
        key: typeName,
        value: typeName
      }, classifierValues[typeName].family + ' - ' + classifierValues[typeName].name);
    })), React.createElement('br', null), React.createElement('br', null)), React.createElement('div', {
      className: libstyle.libBody
    }, React.createElement(IconPack, {
      icons: this.state.currentIcons,
      onIconSelected: this.props.onIconSelected
    })));
  };

  return IconLibrary;
}(Component);

IconLibrary.propTypes = process.env.NODE_ENV !== "production" ? {
  onIconSelected: PropTypes.func.isRequired,
  corporateIcons: PropTypes.array.isRequired
} : {};

var IconPack = function (_Component2) {
  _inherits(IconPack, _Component2);

  function IconPack() {
    _classCallCheck(this, IconPack);

    return _possibleConstructorReturn(this, _Component2.apply(this, arguments));
  }

  IconPack.prototype.render = function render() {
    var _this3 = this;

    var icons = this.props.icons;
    return React.createElement('div', {
      style: {
        overflow: 'auto'
      }
    }, icons.data.map(function (icon, index) {
      var iconName = icon.iconId;
      return (//TODO: selected look & feel?
        React.createElement('div', {
          className: libstyle.iconBox,
          key: index
        }, React.createElement(IconButton, {
          name: iconName //inverted
          //primaryColor='#fff'
          //secondaryColor='#189161'
          ,
          size: '2em',
          shape: SHAPES.ROUNDEDSQUARE //border={5}
          ,
          padding: 10,
          onClick: _this3.props.onIconSelected
        }))
      );
    }));
  };

  return IconPack;
}(Component);

IconPack.propTypes = process.env.NODE_ENV !== "production" ? {
  icons: PropTypes.object.isRequired,
  onIconSelected: PropTypes.func.isRequired
} : {};
export default IconLibrary;